// Global Types
import type {
  $AdminRouteResponse as $ApiRouteResponse,
} from 'common.types';

import {
  admins,
  fullAdminRegattas,
  fullRegions,
  regattaAdmins,
  regattaChecks,
  regattaContacts,
  regattaDocuments,
  regattaMessages,
  regattaRequirements,
  regattas,
} from 'common.data/dist/mocks';

// Service
import ApiService from '../ApiService';

// Types
import type {
  $Config,
} from '../ApiService';

class ApiServiceMock extends ApiService<$Config> {
  constructor(config: $Config) {
    super(config);

    this.initMock((mock) => {
      mock.onPost(this.path('/auth/user/get_one')).reply(() => {
        const responseBody: $ApiRouteResponse<'/auth/user/get_one'> = admins[0];

        return [200, responseBody];
      });

      mock.onPost(this.path('/main/regions')).reply(() => {
        const responseBody: $ApiRouteResponse<'/main/regions'> = fullRegions;

        return [200, responseBody];
      });

      mock.onPost(this.path('/regatta/get_one')).reply(({
        data,
      }) => {
        const body: {
          id: string;
        } = JSON.parse(data);

        const foundItems = fullAdminRegattas.filter((i) => i.id === body.id);

        if (foundItems[0]) {
          const responseBody: $ApiRouteResponse<'/regatta/get_one'> = foundItems[0];

          return [200, responseBody];
        }

        return [400, undefined];
      });

      mock.onPost(this.path('/regatta/get_many')).reply(({
        data,
      }) => {
        const body: {
          RegionSeasonId: string;
        } = JSON.parse(data);

        const foundItems = regattas
          .filter((i) => i.RegionSeasonId === body.RegionSeasonId);

        const responseBody: $ApiRouteResponse<'/regatta/get_many'> = foundItems;

        return [200, responseBody];
      });

      mock.onPost(this.path('/regatta/get_resource')).reply(({
        data,
      }) => {
        const body: {
          RegionSeasonId: string;
        } = JSON.parse(data);

        const foundItems = regattas
          .filter((i) => i.RegionSeasonId === body.RegionSeasonId);

        const responseBody: $ApiRouteResponse<'/regatta/get_resource'> = foundItems;

        return [200, responseBody];
      });

      mock.onPost(this.path('/regatta_admin/get_many')).reply(({
        data,
      }) => {
        const body: {
          RegattaId: string;
        } = JSON.parse(data);

        const ids: Array<string> = regattaAdmins
          .filter((i) => i.RegattaId === body.RegattaId)
          .map((i) => i.AdminId);

        const foundItems = admins.filter((i) => ids.indexOf(i.id) !== -1);

        const responseBody: $ApiRouteResponse<'/regatta_admin/get_many'> = foundItems;

        return [200, responseBody];
      });

      mock.onPost(this.path('/admin/admin/get_many')).reply(() => {
        const customResponse = admins.map((admin) => {
          const updatedAdmin = admin;

          updatedAdmin.Regattas = [];

          return updatedAdmin;
        }) as $ApiRouteResponse<'/admin/admin/get_many'>;

        return [200, customResponse];
      });

      mock.onPost(this.path('/regatta_message/get_many')).reply(() => {
        const responseBody: $ApiRouteResponse<'/regatta_message/get_many'> = regattaMessages;

        return [200, responseBody];
      });

      mock.onPost(this.path('/regatta_document/get_many')).reply(() => {
        const responseBody: $ApiRouteResponse<'/regatta_document/get_many'> = regattaDocuments;

        return [200, responseBody];
      });

      mock.onPost(this.path('/regatta_contact/get_many')).reply(() => {
        const responseBody: $ApiRouteResponse<'/regatta_contact/get_many'> = regattaContacts;

        return [200, responseBody];
      });

      mock.onPost(this.path('/regatta_admin/get_many')).reply(() => {
        const responseBody: $ApiRouteResponse<'/regatta_admin/get_many'> = admins;

        return [200, responseBody];
      });

      mock.onPost(this.path('/regatta_check/get_many')).reply(() => {
        const responseBody: $ApiRouteResponse<'/regatta_check/get_many'> = regattaChecks;

        return [200, responseBody];
      });

      mock.onPost(this.path('/regatta_requirement/get_many')).reply(() => {
        const responseBody: $ApiRouteResponse<'/regatta_requirement/get_many'> = regattaRequirements;

        return [200, responseBody];
      });
    });
  }
}

export default ApiServiceMock;
